// extracted by mini-css-extract-plugin
export default {"base":"BottomSheetHeader_base__bL8LL","content":"BottomSheetHeader_content__8Xn5u"};